// import imageLogoTypeBottom from "../../assets/images/logo-type-gray.png";
// import imageLogoTypeMain from "../../assets/images/logo-type.png";
import React from "react";

interface iBrand {
    height?: number;
    className?: string;
    isMain?: boolean;
}

const Brand: React.FC<iBrand> = (props) => {
    return (
        <div className={`brand-block ${props.className || ''}`}>
            {/*{props.isMain*/}
            {/*    ? <img src={imageLogoTypeMain} alt='' width='166' height={48}/>*/}
            {/*    : <img src={imageLogoTypeBottom} alt='' width='166' height={48}/>*/}
            {/*}*/}
        </div>
    )
}

export default Brand;
